var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C5.92157 3 5.25 3.67157 5.25 4.5V19.5C5.25 20.3284 5.92157 21 6.75 21H17.25C18.0784 21 18.75 20.3284 18.75 19.5V8.25L13.5 3H6.75Z",
    fill: "#C0B0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7534_74118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.25V3L18.75 8.25H13.5Z",
    fill: "#6541F2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16313 17.7852C7.97417 17.7852 7.82036 17.6313 7.82036 17.4424C7.82036 17.2578 7.97417 17.104 8.16313 17.104C8.34331 17.104 8.50151 17.2578 8.50151 17.4424C8.50151 17.6313 8.34331 17.7852 8.16313 17.7852ZM8.92954 18.6465V15.3638H9.47886V15.7549H9.51401C9.6019 15.5835 9.77769 15.333 10.1996 15.333C10.7489 15.333 11.1839 15.7637 11.1839 16.5591C11.1839 17.3457 10.7621 17.7939 10.1996 17.7939C9.78647 17.7939 9.6019 17.5479 9.51401 17.3721H9.49204V18.6465H8.92954ZM9.47886 16.5547C9.47886 17.0205 9.68101 17.3325 10.0458 17.3325C10.4149 17.3325 10.6126 17.0073 10.6126 16.5547C10.6126 16.1108 10.4193 15.79 10.0458 15.79C9.68101 15.79 9.47886 16.0933 9.47886 16.5547ZM12.0734 16.3525V17.75H11.5109V15.3638H12.047V15.7681H12.0778C12.1876 15.5 12.4293 15.333 12.7853 15.333C13.2819 15.333 13.6071 15.6582 13.6027 16.2295V17.75H13.0446V16.3174C13.0446 15.9966 12.8732 15.8076 12.5788 15.8076C12.2799 15.8076 12.0734 16.0054 12.0734 16.3525ZM15.0678 18.6948C14.435 18.6948 14.0351 18.4136 13.9956 17.9653H14.5537C14.5932 18.1719 14.791 18.2729 15.0766 18.2729C15.4106 18.2729 15.6303 18.1279 15.6303 17.7764V17.3193H15.604C15.5161 17.4951 15.3271 17.7148 14.914 17.7148C14.3647 17.7148 13.9296 17.3149 13.9296 16.5371C13.9296 15.7505 14.3647 15.333 14.9184 15.333C15.3403 15.333 15.5161 15.5835 15.604 15.7549H15.6303V15.3638H16.184V17.7896C16.184 18.4004 15.7138 18.6948 15.0678 18.6948ZM15.0678 17.2754C15.4282 17.2754 15.6347 17.0029 15.6347 16.5459C15.6347 16.0933 15.4326 15.79 15.0678 15.79C14.6943 15.79 14.5009 16.1108 14.5009 16.5459C14.5009 16.9854 14.6987 17.2754 15.0678 17.2754Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7534_74118",
    x: 10.5,
    y: 1.5,
    width: 11.25,
    height: 11.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.20694 0 0 0 0 0.51735 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7534_74118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7534_74118",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePng);
export default __webpack_public_path__ + "static/media/file-png.7fdd1e37b46e810b6a01d9202b80d98e.svg";
export { ForwardRef as ReactComponent };